import React, { forwardRef } from "react";
import { classNames } from "../utils/classNames";
import { useFlexStyles } from "./Flex.styles";
export var Flex = forwardRef(function (props, contentRef) {
    var _a;
    var Element = (_a = props === null || props === void 0 ? void 0 : props.elementType) !== null && _a !== void 0 ? _a : "div";
    return (React.createElement(Element, { className: classNames(useFlexStyles(props).flex), role: props === null || props === void 0 ? void 0 : props.role, "aria-label": props["aria-label"], "aria-details": props["aria-details"], ref: contentRef }, props === null || props === void 0 ? void 0 : props.children));
});
